"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gitProfile = void 0;
exports.gitProfile = {
    name: 'remixd.git',
    methods: ['clone', 'checkout', 'init', 'add', 'commit', 'fetch', 'pull', 'push', 'reset', 'status', 'remote', 'log']
};
//# sourceMappingURL=profile.js.map